
(function() {
  var done = false;
  function addQuantityDropdown() {
    if (done) return;
    if (document.querySelector('.qty-dropdown-305')) return;
    
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!form) return;
    done = true;
    
    var input = form.querySelector('input[name="quantity"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      form.appendChild(input);
    }
    
    var container = document.createElement('div');
    container.className = 'qty-dropdown-305';
    container.style.cssText = 'margin:20px 0;';
    
    var label = document.createElement('label');
    label.textContent = 'Quantity (Boxes)';
    label.style.cssText = 'display:block;font-family:Oswald,sans-serif;font-weight:600;font-size:14px;text-transform:uppercase;margin-bottom:8px;letter-spacing:0.5px;';
    
    var select = document.createElement('select');
    select.style.cssText = 'width:120px;padding:12px 16px;font-size:16px;border:2px solid #333;border-radius:8px;background:#fff;cursor:pointer;font-family:Oswald,sans-serif;font-weight:500;';
    
    for (var i = 1; i <= 40; i++) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = i;
      select.appendChild(opt);
    }
    
    select.addEventListener('change', function() {
      input.value = this.value;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
    
    container.appendChild(label);
    container.appendChild(select);
    
    var buyBtn = form.querySelector('.product-form__buttons, [name="add"], button[type="submit"]');
    if (buyBtn) {
      var target = buyBtn.closest('.product-form__buttons') || buyBtn.parentNode;
      target.parentNode.insertBefore(container, target);
    } else {
      form.appendChild(container);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(addQuantityDropdown, 500); });
  } else {
    setTimeout(addQuantityDropdown, 500);
  }
  
  var observer = new MutationObserver(function() {
    if (!document.querySelector('.qty-dropdown-305')) {
      done = false;
      addQuantityDropdown();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();


// Start Shopping button on account page
(function() {
  if (!window.location.pathname.includes('/account')) return;
  function addShopButton() {
    if (document.getElementById('start-shopping-305')) return;
    // Try to find the customer name heading
    var nameEl = document.querySelector('h1, h2, .customer-name, [class*="name"]');
    if (!nameEl) {
      // Fallback: insert at top of main content
      nameEl = document.querySelector('main, .main-content, #MainContent, [role="main"]');
    }
    if (!nameEl) return;
    var btn = document.createElement('a');
    btn.id = 'start-shopping-305';
    btn.href = '/collections/all';
    btn.textContent = 'START SHOPPING';
    btn.style.cssText = 'display:block;width:90%;max-width:400px;margin:20px auto;padding:16px 32px;background:#FF8C00;color:#fff;text-align:center;text-decoration:none;font-family:Oswald,sans-serif;font-weight:800;font-size:18px;text-transform:uppercase;border-radius:8px;letter-spacing:2px;box-shadow:0 4px 15px rgba(255,140,0,0.4);';
    nameEl.parentNode.insertBefore(btn, nameEl);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addShopButton);
  } else {
    addShopButton();
  }
  // Retry for dynamic content
  setTimeout(addShopButton, 1000);
  setTimeout(addShopButton, 2500);
})();
